module.exports = __webpack_public_path__ + "img/goal-eleven-en.00060950.png";